<script setup lang="ts">
import type { Lesson } from '../../model/lessons/interfaces'

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

import { BadgeBookingStatus } from '@shared/ui/badges'
import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'LessonStatus',
})

defineProps<{
  lesson: Lesson
  note: string
}>()
</script>

<template>
  <div class="lesson-status">
    <BadgeBookingStatus
      :status="lesson.status"
      :category="lesson.reason_category ?? undefined"
    />
    <AppTooltip
      v-if="note"
      :text="note"
    >
      <AppIcon
        :icon="faCircleInfo"
        color="slate-500"
      />
    </AppTooltip>
  </div>
</template>

<style scoped lang="scss" src="./LessonStatus.scss" />
